import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

/**
 * Custom hook providing an "authenticated fetch" that:
 * 1. Attaches the current access token
 * 2. Attempts a single refresh+retry on 401
 * 3. Logs out if still unauthorized
 */
export function useApi() {
  const { token, handleTokenRefresh, logout } = useAuth();

  const authFetch = useCallback(
    async (path, options = {}) => {
      // build full URL and headers
      const url = `${API_URL}${path}`;
      let headers = { ...(options.headers || {}) };
      if (token) headers.Authorization = `Bearer ${token}`;

      let response = await fetch(url, { ...options, headers });

      // if unauthorized, try refresh once
      if (response.status === 401 || response.status === 403) {
        const refreshed = await handleTokenRefresh();
        if (refreshed) {
          const newToken = localStorage.getItem('fleasing_b2b_token');
          headers = { ...(options.headers || {}), Authorization: `Bearer ${newToken}` };
          response = await fetch(url, { ...options, headers });
        }
      }

      // if still unauthorized, force logout
      if (response.status === 401 || response.status === 403) {
        logout();
        throw new Error('Unauthorized');
      }

      return response;
    },
    [token, handleTokenRefresh, logout]
  );

  return { authFetch };
}